import React, {useContext, useEffect, useState} from 'react';
import {  createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut  } from 'firebase/auth';
import {auth} from "../firebase";

const AuthContext = React.createContext()

export function useAuth() {
    return useContext(AuthContext)
}

export function AuthProvider({children}) {
    const [currentUser, setCurrentUser] = useState()

     function signup(email, password) {
        return createUserWithEmailAndPassword(auth, email, password)
     }

    function signin(email, password) {
        return signInWithEmailAndPassword(auth, email, password)
    }

    function logout() {
        return signOut(auth)
    }

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setCurrentUser(user)
        })
        return unsubscribe
    }, []);

    const value = {
        currentUser,
        signup,
        signin,
        logout
    }

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};